import { TextField, MenuItem } from '@mui/material'
import React from 'react'
import { User } from '../../interfaces'

interface PickerFilterProps {
  pickers: User[]
  handleChange: (
    e: React.ChangeEvent<{
      name?: string
      value: unknown
    }>
  ) => void
  value: number
}

export const PickerFilter: React.FC<PickerFilterProps> = ({
  pickers,
  handleChange,
  value
}) => {
  return (
    <TextField
      onChange={handleChange}
      id='pickerId'
      name='pickerId'
      value={value}
      variant='outlined'
      select
      fullWidth
    >
      <MenuItem value={0}>Seleccione Pickeador</MenuItem>
      {pickers.map(({ userId, userAlias }) => (
        <MenuItem value={userId}>{userAlias}</MenuItem>
      ))}
    </TextField>
  )
}
